module.exports = __webpack_public_path__ + "img/experience_en.66223d3a.svg";